const getInMemoryStorageImpl = () => {
    console.debug('@clds/feature-flags: using in-memory storage, should be used in the test environment');
    const values = {};
    return {
        setItem: (key, value) => (values[key] = value),
        getItem: (key) => values[key],
    };
};
const getLocalStorageImpl = () => { var _a; return (_a = tryGetLocalStorage()) !== null && _a !== void 0 ? _a : getInMemoryStorageImpl(); };
const tryGetLocalStorage = () => {
    try {
        return window.localStorage;
    }
    catch (e) {
        console.error('@clds/feature-flags: could not access localStorage');
        return null;
    }
};
export const createLocalStorageFeatureFlag = (key) => {
    const localStorageImpl = getLocalStorageImpl();
    const isEnabled = () => localStorageImpl.getItem(key) === 'true';
    return {
        isEnabled,
        setEnabled: (enabled) => localStorageImpl.setItem(key, String(enabled)),
        whenEnabled: (valueWhenEnabled) => ({
            orElse: (defaultValue) => isEnabled() ? valueWhenEnabled : defaultValue,
        }),
    };
};
//# sourceMappingURL=createFeatureFlag.js.map